import { Heading } from "arag-ui-lib"

const StagesDescription = () => {
    return (
    <div>
    <Heading variant="h3" title={"Stage A: From CFA date to 3 years after Date of Incident minus 1 day"} />
    <Heading variant="h3" title={"Stage B: From 3 to 5 years after Date of Incident"} />
    <Heading variant="h3" title={"Stage C: From 5 years after Date of Incident onward"} />
    </div>
    )
}
export default StagesDescription;
